import React from "react";
import Game from "./Game";
import CardsGame from "./CardsGame";

export default function GameCategoriesPage() {
    return (
        <>
            <Game/>
            <CardsGame/>
        </>
    );
}